// src/pages/dashboard/PageShell.jsx
import React from "react";

export default function PageShell({ title, children }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-xl sm:text-2xl font-bold text-secondary">{title}</h2>

        {/* Optional badge (keep it generic) */}
        <span className="text-xs sm:text-sm text-secondary/70 border border-secondary/20 rounded-full px-3 py-1 bg-white/60">
          Admin
        </span>
      </div>

      {/* ✅ IMPORTANT: render page content here */}
      <div>{children}</div>
    </div>
  );
}
